import { render, staticRenderFns } from "./FruechteBoxProductBox.vue?vue&type=template&id=97ccd182"
import script from "./FruechteBoxProductBox.vue?vue&type=script&lang=ts"
export * from "./FruechteBoxProductBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports